import React from 'react';
import {Route, useNavigate} from "react-router-dom";
import {routes} from "./Routes";
import GenerateInvoiceWizard from "../views/invoice/sales/GenerateNewInvoiceWizard";
import {useRouteWithParam} from "../components/RouteWithParam";
import SalesInvoice from "../views/invoice/sales/SalesInvoice";
import InvoiceList, {InvoiceType} from "../views/invoice/InvoiceList";


export const useSalesInvoiceRoutes = () => {
    const navigate = useNavigate();

    return <>
        <Route path={routes.newSalesInvoice} element={<GenerateInvoiceWizard navigate={navigate}/>}/>
        {useRouteWithParam({path: routes.salesInvoice, render: params => <SalesInvoice invoiceId={params.id!!} navigate={navigate}/>})}
        <Route path={routes.salesInvoices} element={<InvoiceList withActions={true} type={InvoiceType.SALES}/>}/>
    </>
}